<template id="banner">
  <div class="card-deck m-1" v-if="call">
    <div class="card-body px-1 pt-1 pb-0">
      <div class="d-flex align-items-center flex-nowrap">

        <div class="mr-4">
          <button @click="showFilterDialog" class="btn btn-sm"
                  v-bind:class="'btn-info'"
          >
            <span style="font-size: .7rem"><i class="fas fa-filter"></i></span>
<!--            <span class="ml-1" v-if="!filterIsSelected">Filter</span>-->
<!--            <span class="ml-1" v-else>{{ filterCount }} Filter(s) Applied</span>-->
          </button>
        </div>

        <dialog ref="dialog">
          <input ref="hiddenInput" type="text" style="position: absolute; opacity: 0;">
          <div class="d-flex flex-column h-100">
            <button @click="hideFilterDialog" class="btn btn-outline"
                    style="position: absolute; right: 10px; top: 30px;font-size: small; background-color: white">
              X
            </button>
            <h5 class="text-left mb-2 pb-2" style="border-bottom: 1px solid #ccc">Filters for Dashboard</h5>
            <div class="flex-grow-1 mb-3" style="overflow-y: auto; overflow-x: hidden">
              <div class="row">
                <!--         Left Section (Filters) -->
                <div v-for="(key,idx) of screenletListboxDim" class="col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column"
                     :key="key">
                  <span class="text-left" style="font-size: .8rem; font-weight: bold">{{
                      SLlistboxDimBizName[idx]
                    }}</span>
                  <div class="anyWhichWay" v-if="screenletListboxType === 'anyWhichWay'">
                    <multiselect
                        v-model="x[key]"
                        :options="getValues(key,x) || []"
                        :multiple="true"
                        select-label="Select"
                        deselect-label="Unselect"
                        :limit="1"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :append-to-body="true"
                    >
                    </multiselect>
                  </div>
                  <div class="freeForm" v-else>
                    <multiselect
                        v-model="x[key]"
                        :options="getFilteredValues(key)"
                        :multiple="true"
                        select-label="Select"
                        deselect-label="Unselect"
                        :limit="1"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :append-to-body="true"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button id="button" class="btn-sm btn-success"
                      @click="loadBannerConfig(x)"> Submit
              </button>
              <button class="btn btn-sm ml-2 text-warning border border-warning" @click="resetLb()" title="Reset"
                      style="background-color: transparent;">
                Clear <i class="fas fa-times-circle"></i>
              </button>
            </div>
          </div>
        </dialog>


        <!-- Right Section (Banner Content) -->
        <div class="d-flex">
          <banner-dc-vizlet
              v-for="(r, index) in bannerData"
              v-bind:key="index"
              :dc-viz="r"
          >
          </banner-dc-vizlet>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import * as d3 from 'd3'
// import * as dc from 'dc'
//  import * as crossfilter from 'crossfilter'
import axios from 'axios'
import {ChartInfo} from '@/models'
import {bus} from '@/bus'
import bannerDcVizlet from '@/components/banner-dc-vizlet'
import _ from 'lodash'
import Multiselect from "vue-multiselect/src/Multiselect.vue";

export default {
  name: 'banner',
  components: {Multiselect, bannerDcVizlet},
  data: () => ({
    call: false,
    bannerData: {},
    example: [],
    showModal: false,
    cmnt: '',
    levelOnePeriodData: [],
    annotations: [],
    screenletListboxCount: null,
    screenletListboxDim: {},
    SLlistboxDimBizName: {},
    currentMenuActionIconsData: {},
    currentMenuListboxData: {},
    optionValues: ['a', 'b'],
    x: {},
    // x: {'d4l1_yyyy': 'All', 'd5l1_name': 'All'}, //need to revisit to make it dynamic
    filterPeriodLevel1: '',
    filterPeriodLevel2: 'quarterly',
    // filterPeriodLevel2: 'weekly',
    //filterPeriodLevel2: 'monthly',
    r1c1: new ChartInfo('R1C1', {}, false, []),
    r1c2: new ChartInfo('R1C2', {}, false, []),
    r1c3: new ChartInfo('R1C3', {}, false, []),
    r1c4: new ChartInfo('R1C4', {}, false, []),
    r1c5: new ChartInfo('R1C5', {}, false, []),
    r1c6: new ChartInfo('R1C6', {}, false, []),
    r1c7: new ChartInfo('R1C6', {}, false, []),
    r1c8: new ChartInfo('R1C8', {}, false, []),
    r1c9: new ChartInfo('R1C0', {}, false, []),
    r1c10: new ChartInfo('R1C10', {}, false, []),
    searching: false,
    screenletListboxType: null
  }),
  computed: {
    filterCount() {
      // eslint-disable-next-line no-unused-vars
      return Object.entries(this.x).filter(([k, v]) => {
        if (Array.isArray(v)) {
          return v.some(val => val != null);  // Only count if there's a valid value
        } else {
          return v != null;  // Only count if non-null and non-undefined
        }
      }).length
    },
    filterIsSelected() {
      return this.filterCount > 0
    },
    getValues() {
      return (key1, x) => {
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        var filteredData = this.example.filter((item) => {
          for (let kkk in x) {
            if (x[kkk] !== 'All') {
              if (x[kkk]) {
                if (item[kkk] === undefined || x[kkk] !== item[kkk]) {
                  return false;
                }
              }
            }
          }
          return true;
        });

        var reducedArray = _.uniq(filteredData.map(kv => kv[key1]));

        // Sort the array based on the months order
        var sortedArray = reducedArray.sort(function (a, b) {
          return months.indexOf(a) > months.indexOf(b) ? 1 : -1;
        });

        // Add "All" option at the beginning of the sorted array
        return ['All', ...sortedArray];
      };
    },
    getFilteredValues() {
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      return (key1) => {
        let sortedArray;

        if (key1 === 'dim4_name') {
          // Sort based on months order
          sortedArray = _.uniq(this.example.map(kv => kv[key1])).sort(function (a, b) {
            return months.indexOf(a) > months.indexOf(b) ? 1 : -1;
          });
        } else {
          // Default sort for other keys
          sortedArray = _.uniq(this.example.map(kv => kv[key1])).sort();
        }

        // Add "All" option at the beginning of the sorted array
        return ['All', ...sortedArray];
      };
    }
  },
  created() {
    //wait for state to be loaded
    this.loadListbox()
    this.loadBannerConfig()
  },
  methods: {
    resetLb: function () {
      // console.log("reset function called")
      this.x = {}
    },
    hideFilterDialog() {
      this.$refs["dialog"].close()
    },
    showFilterDialog() {
      this.$refs["dialog"].showModal()
    },
    periodLOne: function () {
      // console.log("entered the periodLOne")
      this.filterPeriodLevel2 = 'quarterly'
      //  this.filterPeriodLevel2 = 'weekly'
      // this.filterPeriodLevel2 = 'monthly'
      this.dcBannerCharts()
    },
    periodLTwo: function () {
      this.dcBannerCharts()
    },
    filterYear: function (x) {
      Object.keys(x).forEach(function (key) {
        console.log('passed filter key,value', key, x[key])
      })
    },
    fetchListboxData: function (sqlId) {
      return axios.get('/api/fetchListboxData/' + sqlId).then(res => {
        //console.log("Loop increment value inside api",index);
        // console.log('Load salesman called with', sqlId)
        let resData = res.data
        this.example = resData
        //convert set of values into an array using array.from
        //this.optionValues[index] = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
        let temp = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
        console.log('Salesman data option values:', resData, temp)
        //return temp
      }, err => {
        console.error('Error in fetching record', err)
      })
    },
    loadListbox: function () {
      //let submenuParam = this.$route.params.submenuId
      this.$store.dispatch("loadState").then(() => {
        let menuData = this.$store.state.fwConfigMenuScreenRender
        let columnMetadata = this.$store.state.colummnMetaData
        let actionIconsData = this.$store.state.actionIcons
        let listboxData = this.$store.state.listbox
        let currentMenuData = menuData.filter(r => r.menuId === 'Banner')
        //  var screenletActionIconsSyspkArray = currentMenuData[0].screenletActionIconsSyspkArray
        // ?? checking null value and assigning empty array since models.kt returns null instead of empty list
        var screenletActionIconsSyspkArray = currentMenuData[0].screenletActionIconsSyspkArray ? currentMenuData[0].screenletActionIconsSyspkArray : []
        //var screenletListboxSyspkArray = currentMenuData[0].screenletListboxSyspkArray
        var screenletListboxSyspkArray = currentMenuData[0].screenletListboxSyspkArray ? currentMenuData[0].screenletListboxSyspkArray : []
        var currentMenuActionIconsData = actionIconsData.filter(r => screenletActionIconsSyspkArray.includes(r.syspk))
        var currentMenuListboxData = listboxData.filter(r => screenletListboxSyspkArray.includes(r.syspk))
        this.currentMenuActionIconsData = currentMenuActionIconsData //need to add in router function
        this.currentMenuListboxData = currentMenuListboxData
        this.screenletListboxCount = currentMenuListboxData.length
        this.dateRangeFilterFlag = currentMenuData[0].dateRangeFilterDisplayFlag
        this.orderbyTextJson = currentMenuData[0].orderbyTextJson
        var currentMenuListboxSQLId = currentMenuData[0].screenletListbox1_sqlId
        this.screenletListboxType = currentMenuData[0].screenletListboxType
        if (currentMenuListboxSQLId) {
          this.fetchListboxData(currentMenuListboxSQLId)
        }

        currentMenuListboxData.forEach((cmld, index) => {
          // console.log("Test object",cmld.listboxDimName, index); // the name of the current key.
          //console.log("Test object",cmld.listboxDimName, cmld.listboxSqlId); // the value of the current key.
          this.screenletListboxDim[index] = cmld.listboxDimName
          let bizNamefilterdim = columnMetadata.filter(c => c.columnName === cmld.listboxDimName)
          this.SLlistboxDimBizName[index] = bizNamefilterdim[0].bizName
          // this.x[cmld.listboxDimName] = 'All'
        })

        // console.log('Salesman data option values outside:', this.optionValues, this.screenletListboxDim[1], this.optionValues[0])
      })
    },
    loadBannerConfig: function (x) {
      this.$store.dispatch("loadState").then(() => {
        this.call = false
        this.configData = this.$store.state.fwConfigScreenElement
        this.bannerData = this.configData.filter(r => r.menuId === 'Banner')

        let allViztypeData = this.$store.state.vizType
        let viztypeData = allViztypeData.filter((t) => t.viztypeId === 'V77')[0] //need to revisit for changing the hardcoded viztype id value
        this.dataSqlId = this.bannerData[0].datasqlId
        this.viztypeClassName = viztypeData.viztypeClassName


        for (let i = 0; i < this.bannerData.length; i++) {
          this.bannerData[i]['f'] = x
        }

        // can be the string of commonVizClassName in passing it to the data fetch function
        this.$commonFn.crossfilterDatafetch(this.dataSqlId, this.viztypeClassName, x).then(res => {
          this.call = true
          this.$store.state.bannerStatus = true
          console.log('res', res)
          bus.$emit('banner-changed', x)
        })

      })

    }
  }
}
</script>
<style scoped>
dialog {
  width: 66vw;
  height: 66vh;
  margin: auto;
  border: 0 none;
  border-radius: 10px;
  padding: 2em;
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 20%);
}

</style>